module.exports = __webpack_public_path__ + "static/centrality-small-square.94ed2817.png";